export const setArrayPath = (path, newPath) => {
    if(newPath){
        let fpath = path?.split('.');
        //fpath.shift();
        //fpath.shift();
        return `${newPath}.${fpath.join('.')}`
    }else{
        return null;
    }

};

export const setArrayPathForJs = (path, newPath) => {
    if(path?.slice(0, 4) === '{doc') return path

    if(newPath){
        if (typeof path === 'string' && path.startsWith('{') && path.endsWith('}')) {
            path = path.slice(1, -1);
        }
        let fpath = path?.split('.');
        //fpath.shift();
        //fpath.shift();
        newPath = newPath.replace(/\.([0-9]+)$/, '[$1]');
        return `{${newPath}.${fpath?.join('.')}}`
    }else{
        return path;
    }

};